import { render, staticRenderFns } from "./StretchTextarea.vue?vue&type=template&id=1b4bd488&"
import script from "./StretchTextarea.vue?vue&type=script&lang=js&"
export * from "./StretchTextarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports